export const DEFAULT_ZOOM = 16;

export const MAP_STYLE_URL = 'https://tiles.openfreemap.org/styles/positron';
export const MAP_ATTRIBUTION =
    '&copy; <a href="https://openfreemap.org" target="_blank">OpenFreeMap</a> &copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap contributors</a>';
export const ICON_MD_ZOOM = 13;
export const ICON_LG_ZOOM = 11;

export const COLORS = {
    SUCCESS_GREEN: '#6ECB3C',
    BRAND_SECONDARY: '#004FC6',
    GREY: '#8A8A8A',
};
